// Tiny DOM helpers shared across UI modules. Keeping show/hide here
// (instead of reinventing them in each module) matches the legacy
// convention where every screen toggles via a single `.hidden` class.

export function show(el: Element | null): void {
  el?.classList.remove("hidden");
}

export function hide(el: Element | null): void {
  el?.classList.add("hidden");
}

/** Strict getElementById that returns null — thin wrapper for typing. */
export function byId<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}
